import { PATHS } from '../constants/paths'

import { history } from './history'
import { removeToken } from './sessionStorage'

export const disconnect = () => {
  removeToken()
  history.push(PATHS.LOGIN)
}
